module.exports = __webpack_public_path__ + "media/images/fb-icon-color-e88d09ef0f866028e0e8fd380621a543.png";